import {
  BusinessesCreateRoute,
  BusinessesEditRoute,
  BusinessesListRoute,
  BusinessesRoute,
  CollectAuditsListRoute,
  CollectAuditsViewRoute,
  CollectsCreateRoute,
  CollectsEditRoute,
  CollectsListRoute,
  CollectsRoute,
  CollectsViewRoute,
  ExportDataRoute,
  FeatureConstructorForm,
  FeaturesAnalyticsRoute,
  FeaturesCreateRoute,
  FeaturesDuplicateRoute,
  FeaturesEditRoute,
  FeaturesRoute,
  GroupsCreateRoute,
  GroupsEditRoute,
  GroupsListRoute,
  GroupsRoute,
  HomeRoute,
  ImportedDataRoute,
  InitiativesCreateRoute,
  InitiativesDuplicateRoute,
  InitiativesEditRoute,
  InitiativesListRoute,
  InitiativesRoute,
  InitiativesViewRoute,
  LocaleRoute,
  LoginRoute,
  NotAuthorizedRoute,
  PrivateRoute,
  Route,
  SelfAppliedCollectFinishedRoute,
  SelfAppliedCollectRedirectRoute,
  SelfAppliedCollectRoute,
  UsersCreateRoute,
  UsersEditPermissionsRoute,
  UsersEditRoute,
  UsersListRoute,
  UsersRoute,
} from '@/routes/__root.tsx'

export const routeTree = Route.addChildren([
  LoginRoute,
  HomeRoute,
  SelfAppliedCollectRedirectRoute,
  LocaleRoute.addChildren([
    SelfAppliedCollectRoute,
    SelfAppliedCollectFinishedRoute,
    NotAuthorizedRoute,
    PrivateRoute.addChildren([
      UsersRoute.addChildren([
        UsersListRoute,
        UsersEditRoute,
        UsersEditPermissionsRoute,
        UsersCreateRoute,
      ]),
      GroupsRoute.addChildren([
        GroupsListRoute,
        GroupsEditRoute,
        GroupsCreateRoute,
      ]),
      BusinessesRoute.addChildren([
        BusinessesCreateRoute,
        BusinessesListRoute,
        BusinessesEditRoute,
      ]),
      InitiativesRoute.addChildren([
        InitiativesListRoute,
        InitiativesEditRoute,
        InitiativesDuplicateRoute,
        InitiativesCreateRoute,
        InitiativesViewRoute,
        ImportedDataRoute,
        ExportDataRoute,
        FeaturesRoute.addChildren([
          FeaturesCreateRoute,
          FeaturesEditRoute,
          FeaturesDuplicateRoute,
          FeatureConstructorForm,
          FeaturesAnalyticsRoute,
          CollectsRoute.addChildren([
            CollectsListRoute,
            CollectsCreateRoute,
            CollectsEditRoute,
            CollectsViewRoute,
            CollectAuditsListRoute,
            CollectAuditsViewRoute,
          ]),
        ]),
      ]),
    ]),
  ]),
])
